import { Typography } from '@material-ui/core';
import { isAPIError } from 'shared/api/APIError';
import styled from 'styled-components';

const Main = styled.div`
  display: flex;
  flex: 1;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  padding-bottom: 16px;
  min-height: 385px;
`;

function formatError(error: Error) {
  const errorCode = isAPIError(error) && error.type;

  if (errorCode === 'LOAD_NOT_FOUND') {
    return 'Load is no longer available';
  }

  return error.message || 'Something went wrong :(';
}

interface Props {
  error: Error;
}

export function PostingDetailsModalError({ error }: Props) {
  return (
    <Main>
      <Typography variant="h2">{formatError(error)}</Typography>
    </Main>
  );
}
